<template>
  <div id="desktop">
    <div class="wallpaper">
      <img src="@/assets/wallpaper.svg" />
    </div>
    <div id="windows-container">
      <DroneWindow />
      <EmailWindow />
      <NewsWindow />
      <SocialWindow />
    </div>
    <TaskBar />
  </div>
</template>

<script>
import TaskBar from "./TaskBar";
import DroneWindow from "./windows/Drone/DroneWindow";
import EmailWindow from "./windows/Email/EmailWindow";
import NewsWindow from "./windows/News/NewsWindow";
import SocialWindow from "./windows/Social/SocialWindow";

export default {
  name: "Desktop",
  components: { DroneWindow, EmailWindow, NewsWindow, SocialWindow, TaskBar },
};
</script>

<style scoped lang="scss">
#desktop {
  display: flex;
  flex-direction: column;

  height: 100vh;
  width: 100vw;

  background-color: rgb(219, 197, 245);
  color: white;

  .wallpaper {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 70px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 35%;
    }
  }

  #windows-container {
    flex: 1;
  }
}
</style>
